import { Injectable, OnDestroy } from '@angular/core';
import { SocketService } from '@tablesready/frontend-store';
import { merge, Observable, Subject, Subscription } from 'rxjs';
import { WebSocketEventsEnum } from '@shared/websocket';

@Injectable({ providedIn: 'root' })
export class FrontendPartyObserverService implements OnDestroy {
  partyUpdateEvent$: Observable<unknown>;

  private readonly partyUpdateEventSource$ = new Subject<unknown>();
  private readonly subscription = new Subscription();

  constructor(private readonly socketsService: SocketService) {
    this.partyUpdateEvent$ = this.partyUpdateEventSource$.asObservable();

    const socketSub = merge(
      this.socketsService.getEventStream(WebSocketEventsEnum.displayOptions),
      this.socketsService.getEventStream(WebSocketEventsEnum.reservationSettings),
      // Parties and reservations are now updated through the partyUpdated/partyCreated events
      // in ActivePartiesService, which updates the store. This avoids unnecessary API calls.
      // Other components (togo, history, floorplan) have their own subscriptions to these events.

      // this.socketsService.getEventStream(WebSocketEventsEnum.parties),
      // this.socketsService.getEventStream(WebSocketEventsEnum.reservations),

      this.socketsService.getEventStream(WebSocketEventsEnum.TextSmsEvent),
      this.socketsService.getEventStream(WebSocketEventsEnum.VoiceSmsEvent),
      this.socketsService.getEventStream(WebSocketEventsEnum.InboundSmsEvent),
    )
      .subscribe(() => {
        this.partyUpdateEventSource$.next(true);
      });
    this.subscription.add(socketSub);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
